import {
  ApolloClient,
  ApolloLink,
  concat,
  createHttpLink,
  InMemoryCache,
  split,
} from '@apollo/client';
import Auth from '@aws-amplify/auth';
import appSettings from '@/app-settings.json';

export async function getAriadneAuthToken() {
  const user = await Auth.currentAuthenticatedUser();
  return user.getSignInUserSession()?.getIdToken().getJwtToken();
}

export async function getAriadneAuthHeader() {
  const token = await getAriadneAuthToken();
  return {
    authorization: `Bearer ${token}`,
  };
}

export async function getApiDomainAuthHeader() {
  const user = await Auth.currentAuthenticatedUser();
  const token = user.getSignInUserSession().getAccessToken().getJwtToken();

  return {
    authorization: `Bearer ${token}`,
  };
}

// @ts-ignore
const authMiddleware = new ApolloLink(async (operation, forward) => {
  const ariadneAuthHeaders = await getAriadneAuthHeader();
  const apiDomainAuthHeaders = await getApiDomainAuthHeader();

  const apiNameContext = operation.getContext().apiName;

  const authHeaders =
    apiNameContext === ApiSource.ApiDomain
      ? apiDomainAuthHeaders
      : ariadneAuthHeaders;

  operation.setContext(({ headers = {} }) => {
    return {
      headers: {
        ...headers,
        ...authHeaders,
      },
    };
  });

  return forward(operation);
});

function getAriadneBaseUrl() {
  return appSettings.gqlApiEndpoint;
}

function getApiDomainUrl() {
  return `${appSettings.apiDomain}/rentalscape/graphql`;
}

const ariadneHttpLink = createHttpLink({
  uri: getAriadneBaseUrl(),
});

const apiDomainHttpLink = createHttpLink({
  uri: getApiDomainUrl(),
});

export enum ApiSource {
  Ariadne = 'ARIADNE',
  ApiDomain = 'API_DOMAIN',
}

export const apiDomainContext = {
  apiName: ApiSource.ApiDomain,
};

const splitLink = split(
  (operation) => {
    const apiNameContext = operation.getContext().apiName;
    // Default to Ariadne if no context is provided
    return apiNameContext === ApiSource.ApiDomain;
  },
  apiDomainHttpLink,
  ariadneHttpLink
);

export const client = new ApolloClient({
  cache: new InMemoryCache({
    resultCaching: true,
  }),
  link: concat(authMiddleware, splitLink),
});
